import React from "react";
import { ToggleButton, ToggleButtonGroup, Typography } from "@mui/material";
import FunctionsIcon from '@mui/icons-material/Functions'; // Icon for Sum
import ShowChartIcon from '@mui/icons-material/ShowChart'; // Icon for Avg

export default function ViewModeToggle({ value, onChange }) {
    return (
        <ToggleButtonGroup
            value={value}
            exclusive
            onChange={(_, newValue) => {
                if (newValue !== null) onChange(newValue);
            }}
            aria-label="view mode"
            sx={{
                bgcolor: 'background.paper',
                boxShadow: (theme) => theme.palette.mode === 'dark' ? '0 1px 3px rgba(0,0,0,0.5)' : '0 1px 3px rgba(0,0,0,0.1)',
                height: 36,
                '& .MuiToggleButton-root': {
                    px: 1.5,
                    py: 0.5,
                    border: '1px solid',
                    borderColor: 'divider',
                    color: 'text.secondary',
                    '&.Mui-selected': {
                        bgcolor: (theme) => theme.palette.mode === 'dark' ? 'rgba(253, 185, 19, 0.2)' : '#FFF7E0',
                        color: 'primary.main',
                        borderColor: 'primary.main',
                        '&:hover': {
                            bgcolor: (theme) => theme.palette.mode === 'dark' ? 'rgba(253, 185, 19, 0.3)' : '#FFF7E0',
                        }
                    }
                }
            }}
        >
            <ToggleButton value="avg" aria-label="average">
                <ShowChartIcon sx={{ mr: 0.5, fontSize: 18 }} />
                <Typography variant="button" sx={{ fontWeight: 700, fontSize: 11, textTransform: 'none' }}>
                    Média
                </Typography>
            </ToggleButton>
            <ToggleButton value="sum" aria-label="sum">
                <FunctionsIcon sx={{ mr: 0.5, fontSize: 18 }} />
                <Typography variant="button" sx={{ fontWeight: 700, fontSize: 11, textTransform: 'none' }}>
                    Soma
                </Typography>
            </ToggleButton>
        </ToggleButtonGroup >
    );
}
